/**
 * PC 端 rem 动态根字号
 * 设计稿 1920，10rem = 1920px（与 postcss rootValue 192 一致）
 * 视口宽度参与换算：root = clamp(视口, 320~2560) / 10，超宽屏继续随视口放大 rem。
 * 字号下限由 postcss.pc-font-min（仅处理 font-size）实现，不抬高根字号。
 */
const REM_BASE = 10
const MIN_VIEWPORT = 320
const MAX_VIEWPORT = 2560

export function setPcRem() {
  if (typeof document === 'undefined') return

  const width = document.documentElement.clientWidth
  const clamped = Math.min(MAX_VIEWPORT, Math.max(MIN_VIEWPORT, width))

  document.documentElement.style.fontSize = clamped / REM_BASE + 'px'
}

export function clearPcRem() {
  if (typeof document === 'undefined') return

  document.documentElement.style.fontSize = ''
}
